export default __webpack_public_path__ + "static/media/Birthday-announcement-icon.df574880.png";